import { Context, createContext, useContext } from 'react'

export function useStrictContext<T>(context: Context<T | null>) {
  const value = useContext(context)
  if (value === null) throw new Error('Strict context not passed')
  return value
}

export function createStrictContext<T>() {
  return createContext<T | null>(null)
}

export function debounce(func: any, timeout = 300) {
  let timer: NodeJS.Timeout
  return (...args: any) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      // @ts-ignore
      func.apply(this, args)
    }, timeout)
  }
}
